import { Component, OnInit } from '@angular/core';
import { ProjectService, MEDIA_TYPE } from '../../services/project.service';
import { CurrentService } from '../../services/current.service';
import { ModalService } from '../../services/modal.service';
import { PrintService } from '../../services/print.service';
import { CustomerService } from '../../services/customer.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ng-casto-print-medias',
  templateUrl: './print-medias.component.html',
})
export class PrintMediasComponent implements OnInit {
  totalSelectedMediaCount: number = 0;
  totalSelectedPlan2DCount: number = 0;
  totalSelectedRenderHQCount: number = 0;
  totalSelectedSnapshotCount: number = 0;

  medias: any[];

  public printLoading: boolean;

  constructor(
    public project: ProjectService,
    public modalService: ModalService,
    public current: CurrentService,
    private printService: PrintService,
    private customer: CustomerService,
    private translate: TranslateService
  ) {
    this.project.getDetails(current.HBMProject.uuid).then((projectData: any) => {
      let _noCache: string = projectData.dateUpdate.replace(/[\W]+/g, '');

      this.medias = [];

      projectData.medias.snapshot.map((snapshot: any) => {
        this.medias.push({
          url: snapshot.url + '?d=' + _noCache,
          type: MEDIA_TYPE.SNAPSHOT,
          selected: false,
          selectable: true,
        });
      });

      if (projectData.medias.snapshot.length === 0) {
        this.medias.push({
          url: projectData.medias.thumbnail[1].url + '?d=' + _noCache,
          type: MEDIA_TYPE.SNAPSHOT,
          selected: false,
          selectable: true,
        });
      }

      projectData.medias.renderHQ.map((renderHQ: any) => {
        let _hqObj: any = {
          url: 'assets/img/placeholders/project@2x.png',
          type: MEDIA_TYPE.RENDER_HQ,
          selected: false,
          selectable: false,
        };

        let _img = new Image();
        _img.onload = (e: any) => {
          _hqObj.url = renderHQ.url + '?d=' + _noCache;
          _hqObj.selectable = true;
        };
        _img.onerror = (e: any) => {
          _hqObj.url = 'assets/img/placeholders/hqrenders.jpg';
        };
        _img.src = renderHQ.url + '?d=' + _noCache;

        this.medias.push(_hqObj);
      });

      projectData.medias.plan2D.map((plan2D: any) => {
        this.medias.push({
          url: plan2D.url + '?d=' + _noCache,
          type: MEDIA_TYPE.PLAN_2D,
          selected: false,
          selectable: true,
        });
      });
    });
  }

  ngOnInit(): void {}

  selectAll() {
    this.medias.map((media: any) => {
      media.selected = media.selectable;
    });
    this.countSelectedMedia();
  }

  select(media: any) {
    if (!media.selectable) return;
    media.selected = !media.selected;
    this.countSelectedMedia();
  }

  countSelectedMedia() {
    this.totalSelectedMediaCount = 0;
    this.totalSelectedPlan2DCount = 0;
    this.totalSelectedRenderHQCount = 0;
    this.totalSelectedSnapshotCount = 0;

    this.medias.map((media: any) => {
      if (media.selected) {
        this.totalSelectedMediaCount++;

        switch (media.type) {
          case MEDIA_TYPE.PLAN_2D:
            this.totalSelectedPlan2DCount++;
            break;
          case MEDIA_TYPE.RENDER_HQ:
            this.totalSelectedRenderHQCount++;
            break;
          case MEDIA_TYPE.SNAPSHOT:
            this.totalSelectedSnapshotCount++;
            break;

          default:
            break;
        }
      }
    });
  }

  close() {
    this.modalService.close();
  }

  print() {
    this.printLoading = true;
    this.printService.reset();

    this.printService
      .addHeader(this.translate.instant('popins.print.print_title_' + this.customer.context))
      .then(() => {
        if (this.customer.isLogged) {
          this.printService.addText(
            this.translate.instant('popins.products_list.customer_id') + ' ' + this.customer.userDatas.id,
            'my-3'
          );
          this.printService.addText(
            this.translate.instant('popins.products_list.name') + ' ' + this.customer.fullName,
            'my-3'
          );
        }

        this.printService.addText(
          this.translate.instant('popins.products_list.project') +
            ' ' +
            (this.current.HBMProject
              ? this.current.HBMProject.name
              : this.translate.instant('popins.price_info.placeholder_project_' + this.customer.context)),
          'my-3'
        );

        let _rightNow = new Date();
        let _dateStr = _rightNow.toISOString().slice(0, 10).split('-');
        this.printService.addText('Le ' + _dateStr[2] + '/' + _dateStr[1] + '/' + _dateStr[0], 'mt-3 mb-5');

        let _imgToLoadCount = 0;
        let _imgLoaded = 0;

        this.medias.map((media: any) => {
          if (media.selected) {
            _imgToLoadCount++;
            this.printService.addImage(media.url).then(() => {
              _imgLoaded++;
              if (_imgToLoadCount === _imgLoaded) {
                this.printService.print();
                this.printLoading = false;
              }
            });
            this.printService.addPageBreak();
          }
        });
      });
  }
}
